import type { HelpFile } from '../../types/help'
import { AccessTimelineTestIds } from '../../../testids/AccessTimelineTestIds'

export const accessTimelineHelp: HelpFile = {
  docPage: '/docs/identity/access-timeline',
  texts: {
    [AccessTimelineTestIds.accessTimeline]:
      'Chronologische Historie aller Zugriffsänderungen — jede Vergabe, Entziehung und Genehmigung, die den effektiven Zugriff einer Identität geformt hat.',
    [AccessTimelineTestIds.timelineEmpty]:
      'Für diese Identität sind noch keine Zugriffsereignisse erfasst.',
    [AccessTimelineTestIds.timelineLoading]: null,
  },
}
